import React from 'react'
import TitleSVG from '../images/TitleSVG'

const Header = () => {
  return (
    <div>
      <TitleSVG />
    </div>
  )
}

export default Header
